export default __webpack_public_path__ + "static/media/nav.602bc82b.png";